import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';
import BMTabs from './BMTabs';
const {Text, Paragraph} = Typography;
const Content = Layout;

const Siete = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Bussines Model Canva</Paragraph>
        <Text className='BaseText2'>The business model canvas is made up of 9 different sections. At the heart of the business model stand the key propositions of our product. On the right of the canvas, the sales are described by the customer segments,channels, and revenue streams. On the left, the main problem, solution and key metrics are explained. <b>With this business model canvas, we compare the different possible scenarios for the implementation of iMoAge and we conclude that our biosensor would be a very attractive tool that could be helpful for the health sector</b> in low and middle country sectors. To know more about each segment click in the sections below:</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image style={{borderRadius: '8vh'}} src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-23.png'/>
          <p><b>Fig. 6.</b> Preview of the Bussiness Model Canva sectioned </p>
        </Content>
        <BMTabs/>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Siete;
